// src/filters/index.js
// Arquivo único para registrar todos os filtros globais (Vue 2)
// Exporte funções puras também para uso em JS.

// ---- Funções puras ----
export function formatCNPJ(value) {
  if (value === null || value === undefined || value === '') return '-'
  const digits = String(value).replace(/\D/g, '')
  // Se tiver 11 dígitos, formatar como CPF
  if (digits.length === 11) {
    return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
  }
  // Se tiver 14 dígitos, formatar como CNPJ
  if (digits.length === 14) {
    return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
  }
  // Caso contrário, retornar o valor original
  return String(value)
}

// Converte datetime para data no formato brasileiro (dd/mm/yyyy hh:mm)
export function formatDateTimeBR(value) {
  if (!value) return ''
  const date = new Date(value)
  if (isNaN(date)) return value
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${day}/${month}/${year} ${hours}:${minutes}`
}





// Converte datetime para data no formato brasileiro (dd/mm/yyyy)
export function formatDateBR(value) {
  if (!value) return ''
  const date = new Date(value)
  if (isNaN(date)) return value
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${day}/${month}/${year}`
}

// Recebe uma letra e retorna "Proventos" ou "Desconto"
export function tipoProventoDesconto(value) {
  if (!value) return ''
  if (value === 'P') return 'Proventos'
  if (value === 'D') return 'Desconto'
  return value
}

// Converte decimal para formato brasileiro de moeda (R$ 1.234,56)
export function formatBRL(value) {
  if (value === null || value === undefined || value === '') return ''
  const number = Number(value)
  if (isNaN(number)) return value
  return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export function formatBRL2(value) {
  if (value === null || value === undefined || value === '') return ''
  // Troca vírgula por ponto para conversão correta
  const number = Number(
    typeof value === 'string' ? value.replace('.', '').replace(',', '.') : value
  )
  if (isNaN(number)) return value
  return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

// Converte string para letra minúscula
export function letraMinuscula(value) {
  if (!value) return ''
  return String(value).toLowerCase()
}

// Converte string para primeira letra maiúscula e o resto minúscula
export function letraCapitalizada(value) {
  if (!value) return ''
  const str = String(value).toLowerCase()
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function dataEmissaoSped(value) {
  if (!value) return ''
  const day = value.substring(0, 2)
  const month = value.substring(2, 4)
  const year = value.substring(4, 8)
  return `${day}/${month}/${year}`
}

export function dataEmissaoNFstock(value) {
  if (!value) return ''
  value =  value.replaceAll('-', '')
  const day = value.substring(6, 8)
  const month = value.substring(4, 6)
  const year = value.substring(0, 4)
  return `${day}/${month}/${year}`
}

// ---- Registro global ----
export default function registerFilters(Vue) {
  Vue.filter('cnpj', formatCNPJ)
  Vue.filter('datebr', formatDateBR)
  Vue.filter('tipoPD', tipoProventoDesconto)
  Vue.filter('brl', formatBRL)
  Vue.filter('brl2', formatBRL2)
  Vue.filter('formatDateTimeBR', formatDateTimeBR)
  Vue.filter('letraMinuscula', letraMinuscula)
  Vue.filter('dataEmissaoSped', dataEmissaoSped)
  Vue.filter('dataEmissaoNFstock', dataEmissaoNFstock)
  Vue.filter('letraCapitalizada', letraCapitalizada)

}
